import { ThemeEvents } from '@theme/events';

/**
 * A custom element that shows or hides the in-bond info banner
 * based on the selected product variant.
 *
 * The banner is visible only when the selected variant has the metafield
 * erp.purchase_type set to "in_bond". Variants with purchase_type "duty_paid"
 * or without this metafield will have the banner hidden.
 *
 * Visibility is synced on variant change by reading the hidden attribute from the
 * re-rendered section HTML provided by the variant:update event.
 */
class InBondBanner extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * Syncs visibility with the re-rendered section HTML.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newEl = event.detail.data.html.querySelector(
      `in-bond-banner[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newEl) return;

    if (newEl.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('in-bond-banner')) {
  customElements.define('in-bond-banner', InBondBanner);
}
